module.exports = __webpack_public_path__ + "static/media/kofi_blue.820f58bb.png";